import ReactModal from "react-modal";
import { AbconetApi } from '../General/AbconetApi';
import Select from 'react-select';
import React, { Fragment } from 'react';
import { Form, Text, NestedField, Checkbox, Field } from 'react-form';

var ProductSelector = require('../General/Selectors/ProductSelector').ProductSelector;

export class TemplateModify extends React.Component {
    constructor(props) {
        super();
        this.state = {
            isSaving: false,
            isSaved: false,
            modalOpen: false,
            submittedValues: {
                seqno: 0,
                product: "",
                quantity: 0,
                rechargeable: false,
                rechargePercentage: null,
                generalLedgerCode: null,
                generalLedgerCodeRechargeable: null                
            },
            data: {
                action: "addproduct",
                stockcode: null,
                stockcodeReplacement: null,
                searchTerm: null
            },
            templateCount: -1
        }
    }

    openModal() {
        this.setState({
            modalOpen: true
        });
    }

    closeModal() {
        this.setState({
            modalOpen: false
        });
    }

    sendStateToServer() {
        this.setState({ isSaving: true });

        AbconetApi.post(`/api/template/product`, this.state.data).then(
            (template) => {
                setTimeout(
                    () => {
                        this.setState({ isSaved: true, isSaving: false });

                        setTimeout(() => {
                            window.location = "/templates";
                        },
                            300);
                    },
                    200);
            });
    }

    getWillAffectTemplateCount() {
        if (this.state.data.action == null) {
            return;
        }

        if (this.state.data.stockcode == null) {
            return;
        }

        if (this.state.data.action == "replaceproduct" && this.state.data.stockcodeReplacement == null) {
            return this.setState({ templateCount: 0 });           
        }

        console.log(this.state.data);

        AbconetApi.post(`/api/template/getwillaffecttemplate`, this.state.data).then(
            (templateCount) => {
                setTimeout(
                    () => {
                        this.setState({ templateCount });                        
                    },
                    200);
            }
        );
    }

    handleSubmitButton(submittedValues) {
        if (submittedValues.productSearch == '' || submittedValues.productSearch == undefined) {
            alert("Please select product.");
            return;
        }

        var data = { ...this.state.data };
        data.stockcode = submittedValues.productSearch.stockcode;  

        if (this.state.data.action == "replaceproduct") {
            if (data.stockcodeReplacement == '' || data.stockcodeReplacement == undefined) {
                alert("Please select product replacement.");
                return;
            }
        
            data.stockcodeReplacement = submittedValues.productReplacement.stockcode
        }

        this.setState({ data: data }, this.sendStateToServer);
    }

    renderSubmitButton() {
        var btnText = 'Submit';
        var btnClass = 'changes';
        if (this.state.isSaved) {
            btnText = 'Saved';
            btnClass = 'saved';
        }

        if (this.state.isSaving) {
            btnText = 'Saving';
            btnClass = 'saving';
        }

        return <button className={"btn btn-primary float-right mt-4 " + btnClass} >{btnText}</button>;
    }

    handleActionChange(ev) {
        var data = { ...this.state.data };
        data.action = ev.value;

        this.setState({ data: data }, () => { this.getWillAffectTemplateCount() });
    }

    handleSearchTermChange(ev) {
        var data = { ...this.state.data };
        data.searchTerm = ev.target.value;

        this.setState({ data:data }, () => { this.getWillAffectTemplateCount() });
    }

    handleProductChange(ev) {
        var data = { ...this.state.data };
        data.stockcode = ev.stockcode;

        this.setState({ data: data }, () => { this.getWillAffectTemplateCount() });
    }

    handleProductReplacementChange(ev) {
        var data = { ...this.state.data };
        data.stockcodeReplacement = ev.stockcode;

        this.setState({ data: data }, () => { this.getWillAffectTemplateCount() });
    }

    renderAction() {
        const { action } = this.state.data.action;
        var options = [
            { value: 'addproduct', label: 'Add' },
            { value: 'deleteproduct', label: 'Remove' },
            { value: 'replaceproduct', label: 'Replace' },
        ];

        return <div>
            <div className="col-12"> Action
            </div>
            <div className="col-12">
                <Select
                    className="sort-by-dropdown override-dropdown-width"
                    value={action}
                    onChange={this.handleActionChange.bind(this)}
                    options={options}
                    placeholder="Select.."
                />
            </div >
        </div>;
    }

    setChange() {
        this.setState({ isSaved: false });
    }

    render() {
        var self = this;

        return <div>
            <ReactModal  isOpen={this.state.modalOpen} onRequestClose={this.closeModal.bind(this)} portalClassName="modal-portal" className="modal-dialog override-modal-margin"  overlayClassName="modal" bodyOpenClassName="modal-open" >
                <Form
                    defaultValues={this.state.submittedValues}
                    onChange={this.setChange.bind(this)}
                    onSubmit={this.handleSubmitButton.bind(this)} >
                    {formApi => {

                        return (
                            <div>
                                <form onSubmit={formApi.submitForm} id="dynamic-form">
                                    <div className="modal-content">
                                        <div className="bd p-15">
                                            <h5 className="m-0">Modify Templates</h5>
                                        </div>
                                        <br/>
                                        {this.renderAction()}

                                        <div className="mt-4">
                                            <div className="col-12"> Product </div>
                                            <div className="col-12">
                                                <ProductSelector field="productSearch" onChange={(e) => this.handleProductChange(e)}  />
                                            </div>
                                            <br />
                                            {this.state.data.action == "replaceproduct" && <div>  <div className="col-12"> Replacement </div>
                                                <div className="col-12">
                                                    <ProductSelector field="productReplacement" onChange={(e) => this.handleProductReplacementChange(e)}/>
                                                </div> <br /> </div>}

                      
                                                <div className="col-12" >
                                                    Template Name
                                                <Text field="searchTerm" type="text" className="form-control" onInput={(e) => this.handleSearchTermChange(e)} />
                                                </div>
                                
                                            {this.state.templateCount > -1 && <div className="col-12 text-right " style={{fontSize:"13px"}} >
                                                Will affect {this.state.templateCount} templates
                                            </div>
                                            }

                                            {this.renderSubmitButton()}

                                        </div>



                                        <button onClick={this.closeModal.bind(this)} className="close"><span aria-hidden="true">&times;</span></button>
                                    </div>
                                </form>

                            </div>
                        )
                    }
                    }
                </Form>
            </ReactModal>
            <a href="#" className="btn btn-outline-secondary" onClick={this.openModal.bind(this)}>
                Modify Templates
            </a>
        </div>;
    }
}